import { render, staticRenderFns } from "./addOwnerMember.vue?vue&type=template&id=8653cb66&scoped=true"
import script from "./addOwnerMember.vue?vue&type=script&lang=js"
export * from "./addOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./addOwnerMember.vue?vue&type=style&index=0&id=8653cb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8653cb66",
  null
  
)

export default component.exports